<div class="home-btn d-none d-sm-block">
  <a routerLink=""><i class="mdi mdi-home-variant h2 text-dark"></i></a>
</div>
<div>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-lg-7 bg-light">
        <div
          class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
        >
          <div class="w-100">
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div>
                  <div class="text-center">
                    <div>
                      <img
                        src="assets/images/logo_qrpaybox-bup.png"
                        width="180"
                        alt="logo"
                      />
                    </div>

                    <h4 class="font-size-18 mt-4">Đặt lại mật khẩu</h4>
                    <!-- <p class="text-muted">Reset your password to Nazox.</p> -->
                  </div>

                  <div class="p-2 mt-5">
                    <div class="alert alert-success mb-4" role="alert">
                      Nhập số điện thoại của bạn!
                    </div>
                    <form
                      class="form-horizontal"
                      [formGroup]="resetForm"
                      (ngSubmit)="onSubmit()"
                    >
                      <ngb-alert
                        type="danger"
                        *ngIf="error"
                        [dismissible]="false"
                        >{{ error }}</ngb-alert
                      >

                      <div class="form-group auth-form-group-custom mb-4">
                        <i class="ri-phone-line auti-custom-input-icon"></i>
                        <label for="phone">Số điện thoại</label>
                        <input
                          type="phone"
                          formControlName="phone"
                          class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"
                          id="phone"
                          placeholder="Nhập số điện thoại"
                        />
                        <div
                          *ngIf="submitted && f.email.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.phone.errors.required">
                            Số điện thoại bắt buộc
                          </div>
                          <div *ngIf="f.phone.errors.phone">
                            Số điện thoại không hợp lệ
                          </div>
                        </div>
                      </div>

                      <div class="mt-4 text-center">
                        <button
                          class="btn btn-viettel btn-outline-danger waves-effect waves-light col-12"
                          type="submit"
                        >
                          Đặt lại
                        </button>
                      </div>
                    </form>
                  </div>

                  <div class="mt-5 text-center">
                    <p>
                      <a
                        routerLink="/account/login-mobile"
                        class="font-weight-medium waves-effect waves-light text-white btn btn-viettel btn-outline-danger"
                      >
                        Quay lại
                      </a>
                    </p>
                    <!-- <p>© 2020 Nazox. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesdesign</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-block">
        <div
          class="row justify-content-center align-items-center"
          style="height: 100vh;"
        >
          <div class="col-auto">
            <img
              class="img-fluid"
              src="assets/images/logo-login.jpg"
              alt="bg-logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- end page -->
